export const emptyRichText = (text: string) => {
  if (text) {
    const doc = new DOMParser().parseFromString(text, "text/html");
    for (const node of doc.body.childNodes) {
      if (node.textContent) return false;
    }
  }
  return true;
};
